<template>
  <g>
    <path
      d="M4.5 12.0002C5.88071 12.0002 7 10.8809 7 9.50018C7 8.11947 5.88071 7.00018 4.5 7.00018C3.11929 7.00018 2 8.11947 2 9.50018C2 10.8809 3.11929 12.0002 4.5 12.0002Z"
    />
    <path
      d="M9 8.00018C10.3807 8.00018 11.5 6.8809 11.5 5.50018C11.5 4.11947 10.3807 3.00018 9 3.00018C7.61929 3.00018 6.5 4.11947 6.5 5.50018C6.5 6.8809 7.61929 8.00018 9 8.00018Z"
    />
    <path
      d="M15 8.00018C16.3807 8.00018 17.5 6.8809 17.5 5.50018C17.5 4.11947 16.3807 3.00018 15 3.00018C13.6193 3.00018 12.5 4.11947 12.5 5.50018C12.5 6.8809 13.6193 8.00018 15 8.00018Z"
    />
    <path
      d="M19.5 12.0002C20.8807 12.0002 22 10.8809 22 9.50018C22 8.11947 20.8807 7.00018 19.5 7.00018C18.1193 7.00018 17 8.11947 17 9.50018C17 10.8809 18.1193 12.0002 19.5 12.0002Z"
    />
    <path
      d="M17.34 14.8602C16.47 13.8402 15.74 12.9702 14.86 11.9502C14.4 11.4102 13.81 10.8702 13.11 10.6302C13 10.5902 12.89 10.5602 12.78 10.5402C12.53 10.5002 12.26 10.5002 12 10.5002C11.74 10.5002 11.47 10.5002 11.21 10.5502C11.1 10.5702 10.99 10.6002 10.88 10.6402C10.18 10.8802 9.60002 11.4202 9.13002 11.9602C8.26002 12.9802 7.53002 13.8502 6.65002 14.8702C5.34002 16.1802 3.73002 17.6302 4.03002 19.6602C4.32002 20.6802 5.05002 21.6902 6.36002 21.9802C7.09002 22.1302 9.42002 21.5402 11.9 21.5402H12.08C14.56 21.5402 16.89 22.1202 17.62 21.9802C18.93 21.6902 19.66 20.6702 19.95 19.6602C20.26 17.6202 18.65 16.1702 17.34 14.8602Z"
    />
  </g>
</template>
